import React, { Component, ErrorInfo, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

interface Props {
    children?: ReactNode
    navigate: any
}

interface State {
    hasError: boolean
    error: any
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: {},
    }

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: _ }
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Uncaught error:', error, errorInfo)
    }

    public render() {
        if (this.state.hasError) {
            if (this.state.error && this.state.error.code === 'MODULE_NOT_FOUND') {
                this.props.navigate('/notfound', { state: this.state })
            }
        }

        return this.props.children
    }
}

function ErrorBoundaryWithNavigation(props: any) {
    const navigate = useNavigate()
    return <ErrorBoundary {...props} navigate={navigate} />
}

export default ErrorBoundaryWithNavigation
